import React from "react"
import { Input } from "antd";

const InputText = React.forwardRef(({label, className = '', ...props}, ref) => (
  <Input className={className} {...props} ref={ref}/>
))

export default InputText
